export const linkToService = 'https://b24-ew466w.b24site.online/crm_form_jipkm/';
